import {
    useCallback,
    useEffect,
    useMemo,
    useState,
} from 'react';

import {
    MaxUint256,
} from 'ethers'; // 引入ethers库中的最大整数常量，用于无限授权额度
import { toast } from 'react-toastify';

import useConnectWallet from '@/store/wallet/useConnectWallet';
import { evmCAddress } from '@/store/wallet/tools/contract/cAddress';
import { evmChain } from '@/collocate';

const useGetAllowanceToken = (type = 0) => {
    // 从useWallet钩子中获取钱包地址、链ID和合约实例
    const { address, contractEvm: { TokenErc20 }, chainId } = useConnectWallet('evm')
    // 定义一个状态变量，用于存储用户的授权额度
    const [allowance, setAllowance] = useState<bigint>(BigInt(0))
    const conAddress = useMemo(() => {
        return [
            evmCAddress[chainId || evmChain[0]].FlexibleStaking.address, // 活期质押合约地址
            evmCAddress[chainId || evmChain[0]].RegularStaking.address, // 定期质押合约地址
        ]
    }, [chainId])
    // 定义一个状态变量，用于标识加载状态
    const [allowanceLod, setLoading] = useState(false)
    const [allowanceLodFun, setLoadingFun] = useState(false)
    // 获取授权额度的函数
    const getAllowance = useCallback(async () => {
        // 确保钱包地址和ERC20合约实例存在
        if (address && TokenErc20) {
            setLoading(true) // 启动加载状态
            try {
                // 查询授权额度
                const allowances = await TokenErc20.allowance(address, conAddress[type])
                setAllowance(allowances) // 更新授权额度状态
            } catch (e) {
                setAllowance(BigInt(0)) // 出现错误时将授权额度设为0
                console.log('useGetAllowance', e)
            }
            setLoading(false) // 停止加载状态
        }
    }, [address, TokenErc20, conAddress, type])

    // 执行授权的函数
    const approve = async (toastText: { success: string, error: string }) => {
        // 确保ERC20合约实例存在
        if (TokenErc20) {
            setLoadingFun(true) // 启动加载状态
            try {
                // 执行授权，授权额度为最大整数，表示无限授权
                const tx = await TokenErc20.approve(conAddress[type], MaxUint256)
                await tx.wait(); // 等待交易上链
                toast.success(toastText.success);
                // 重新查询授权额度
                getAllowance()
            } catch (e) {
                console.log('useGetAllowance', e) // 打印错误信息
                toast.error(toastText.error);
            } finally {
                setLoadingFun(false)
            }
        }
    }

    // 初始化时或依赖变更时调用getAllowance查询授权额度
    useEffect(() => {
        getAllowance()
    }, [getAllowance])

    // 返回当前授权额度、加载状态、授权函数和查询额度函数
    return { allowance, allowanceLod, approve, allowanceLodFun, getAllowance }
}

export default useGetAllowanceToken